<template>
  <form @submit.prevent="submit">
    <template v-if="initialized">
      <h5 class="mb-3">
        Kontaktuppgifter
      </h5>

      <div class="mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">Namn* <i class="fal fa-user-alt ml-2"></i></div>
          </div>
          <input type="text" class="form-control" placeholder="John Doe" required v-model="customerName">
        </div>
      </div>

      <div class="mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">Bolagsnamn <i class="fal fa-industry-alt ml-2"></i></div>
          </div>
          <input type="text" class="form-control" placeholder="SalesByte AB" v-model="clientCompany">
        </div>
      </div>

      <div class="mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">Mobilnummer* <i class="fal fa-mobile ml-2"></i></div>
          </div>
          <input type="phone" class="form-control" placeholder="+467..." required minlength=5 v-model="customerPhone">
        </div>
      </div>

      <div class="mb-3">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text">E-post <i class="fal fa-envelope ml-2"></i></div>
          </div>
          <input type="email" class="form-control" placeholder="john@salesbyte.se" v-model="customerEmail">
        </div>
      </div>

      <template v-if="formType == 'caparol-basic'">
        <leads-fieldset-caparol-basic v-model="formData" />
      </template>

      <hr>

      <button type="submit" class="btn btn-primary" @click="createQuoteAfterSubmit = false">{{submitText}}</button>

      <a v-if="quoteId" :href="`/offerter/${quoteId}/redigera`" class="btn btn-primary">Gå till offert</a>
      <button v-else type="submit" class="btn btn-primary" @click="createQuoteAfterSubmit = true">{{submitAndCreateOffertText}}</button>
    </template>
    <template v-else>
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Laddar...</span>
      </div>
    </template>
  </form>
</template>

<style lang="scss" scoped>
</style>

<script setup lang="ts">
import axios from "axios";
import { computed, onMounted, ref } from "vue";

interface Props {
    id?: string;
    formType?: string | null;
}

interface LeadFormData {
    [key: string]: unknown;
}

const props = withDefaults(defineProps<Props>(), {
    id: "new",
    formType: null,
});
const customerName = ref<string>();
const clientCompany = ref<string>();
const customerPhone = ref<string>();
const customerEmail = ref<string>();
const formData = ref<LeadFormData | null>(null);
const quoteId = ref<number | null>(null);
const initialized = ref(false);
const createQuoteAfterSubmit = ref(false);
const submitText = computed(() => props.id !== "new" ? "Spara" : "Skapa");
const submitAndCreateOffertText = computed(() => props.id !== "new" ? "Spara och konvertera till offert" : "Skapa och konvertera till offert");

onMounted(async () => {
    if (props.id !== "new") {
        const response = await axios.get(`/leads/${props.id}`);
        customerName.value = response.data.customer_name;
        clientCompany.value = response.data.client_company;
        customerPhone.value = response.data.customer_phone;
        customerEmail.value = response.data.customer_email;
        formData.value = response.data.form_data;
        quoteId.value = response.data.quote_id;
    }

    initialized.value = true;
});

async function submit(): Promise<void> {
    const method = props.id !== "new" ? "patch" : "post";
    const url = props.id !== "new" ? `/leads/${props.id}` : "/leads";
    const response = await axios.request({
        method,
        url,
        data: {
            customer_name: customerName.value,
            client_company: clientCompany.value,
            customer_phone: customerPhone.value,
            customer_email: customerEmail.value,
            form_data: formData.value,
        },
    });

    document.location.href = createQuoteAfterSubmit.value
        ? `/offerter/skapa?lead_id=${response.data.id}`
        : "/leads";
}
</script>
